import React from "react";
import get from "lodash/get";
import includes from "lodash/includes";

const PlanTile = (props) => {
  const { type, user, momentTZ } = props;

  // Admin, ambassador coach and trial all use the same tile
  // except trial shows a upgrade section
  if (includes(["admin", "ambassador", "coach", "trial"], type)) {
    let accountTypeLabel;

    switch (type) {
      case "admin":
        accountTypeLabel = "Administrator";
        break;
      case "ambassador":
        accountTypeLabel = "Ambassador";
        break;
      case "coach":
        accountTypeLabel = "Coach";
        break;
      default:
        accountTypeLabel = "Trial";
        break;
    }

    let trialEndDate;
    if (type === "trial") {
      trialEndDate = momentTZ(get(user, "stripe.trial_end"));
    }

    return (
      <div className={`tile Plan-${accountTypeLabel || "Trial"}`}>
        <div className="inset">
          <div className="title">
            Account Type
            <b>{accountTypeLabel}</b>
          </div>
          {type === "trial" && (
            <div>
              <p>You have {trialEndDate.diff(momentTZ(), "days")} days left</p>
              <a href="/dashboard/settings/subscription" className="button">
                Upgrade
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Tile for paying members

  if (includes(["premium", "standard"], type)) {
    const periodEndDate = momentTZ(get(user, "stripe.period_end"));

    const plan = get(user, "stripe.plan");
    // get the friendly wording for the user's plan type to display
    const billingFrequencyString =
      {
        trial: "trialing",
        launch_oneMonth: "monthly",
        launch_threeMonth: "quarterly",
        launch_twelveMonth: "yearly",
        v2_premium_monthly: "monthly",
        v2_premium_annually: "yearly",
        v2_standard_monthly: "monthly",
        v2_standard_anually: "yearly",
      }[plan] || "";

    return (
      <div className="Plan-Premium tile">
        {user.cancelled ? (
          <div className="status cancelled">
            <b>Subscription cancelled.</b> Active until{" "}
            <b>{periodEndDate.format("MMM. DD, YYYY")}</b>
          </div>
        ) : (
          <div className="status">
            Renewal Date:{" "}
            <b>
              {periodEndDate.format("MMM. DD, YYYY")} ({billingFrequencyString})
            </b>
          </div>
        )}
        <div className="inset">
          <div className="title">
            Current Plan
            <b>{type === "premium" ? "Premium" : "Standard"}</b>
          </div>
          <p>Manage your account:</p>
          <a href="/dashboard/settings" className="text-button icon">
            <img src="/img/svg/icon_edit_white.svg" alt="icon" />
            Settings
          </a>
        </div>
      </div>
    );
  }
};

export default PlanTile;
